'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * Generates a pseudo random string for DOM ids
 * Will return 'test' in the NODE test-env so things like storyshots doesnt break.
 */
var randomId = exports.randomId = function randomId(prefix) {
  var id = process.env.NODE_ENV === 'test' ? 'test' : (Math.random() + Math.random() + 1).toString(36).substring(2);
  return prefix + '-' + id;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@rmwc/base/utils/randomId.js
// module id = 451
// module chunks = 0